import { getCoreSetupAuditTrailSectionsSlice } from './get';

export const { requestGetCoreSetupAuditTrailSections, resetGetCoreSetupAuditTrailSections } =
getCoreSetupAuditTrailSectionsSlice.asyncActionCreators;
